import PropTypes from "prop-types";
import React from "react";
import {Link, Route} from "react-router-dom";
import omit from "lodash/omit";
import s from "./HeaderTab.pcss";

const HeaderTab = ({to, children, id, name, activeClassName, inactiveClassName, ...rest}) => {
    const path = typeof to === "object" ? to.pathname : to;
    return (
        <Route path={path}>
            {({match}) => {
                const isActive = !!match;
                return (
                    <Link
                        {...omit(rest, ["icon"])}
                        id={`${id}-tab`}
                        key={id}
                        className={
                            isActive
                                ? [activeClassName, s.link, s.selected].filter((i) => i).join(" ")
                                : [inactiveClassName, s.link].filter((i) => i).join(" ")
                        }
                        to={to}
                    >
                        <div className={s.icon}>
                            {typeof children === "function" ? children({isActive}) : children}
                        </div>
                        <div className={s.text}>{name}</div>
                    </Link>
                );
            }}
        </Route>
    );
};

HeaderTab.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    to: PropTypes.string.isRequired,
};

export default HeaderTab;
